import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR } from '../../utils/constants.js'

const Dot = styled.span`
    display: inline-block;
    flex-shrink: 0;
    width: ${props => props.size};
    height: ${props => props.size};
    border-radius: 50%;
    background-color: ${props => props.color};
`;

const getStatusColor = (booking) => {
    if (booking?.isClose) return COLOR.ironOrange;
    if (booking?.isToday) return COLOR.expandedGreen;
    if (booking?.isPast) return COLOR.grayClear;
    return COLOR.grayClear;
};

const StatusDot = (props) => {
    const color = getStatusColor(props.booking);
    if (!color) return null;
    return (
        <Dot
            color={color}
            size={props.size ? props.size : '14px'}
            aria-hidden='true'/>
    );
}

StatusDot.propTypes = {
    booking: PropTypes.object,
    size: PropTypes.string
}

export default StatusDot;
